(function () {

    // save the section id from the script tag and find the section
    const sectionID = document.currentScript.dataset.id;
    const section = document.querySelector(`#${sectionID}`);

    // exit if section is not found
    if (!section) {
        console.warn(`Product section with ID ${sectionID} not found.`);
        return;
    }

    // get the key values from the section
    let product = JSON.parse(section.querySelector(".productV8JSON").textContent);
    let activeVariant = JSON.parse(section.querySelector(".productV8VariantJSON").textContent);
    let quantity = 1;

    // check if we need to force sold out
    let forceSoldOut = JSON.parse(section.dataset.soldOut);

    // during dev mode, set the active variant to the window so it can be accessed in the console
    if (Shopify.theme.role === "development") {
        window.product = product;
        window.activeVariant = activeVariant;
    }

    /************
     Product Swiper
     ************/

    let productSwiper = new Swiper(section.querySelector(".productV8VisualSwiper"), {
        slidesPerView: 1,
        spaceBetween: 40,
        navigation: {
            nextEl: section.querySelector('.productV8VisualNext'),
            prevEl: section.querySelector('.productV8VisualPrev'),
        },
        scrollbar: {
            el: section.querySelector('.productV8VisualScroll'),
            draggable: true,
        },
        loop: true,
        autoHeight: true,
        on: {
            slideChange: function () {
                if (!section.querySelector(".productV8VisualSwiperSlide")) {
                    return;
                }
                // update the thumbnail active class
                section.querySelector(".productV8VisualThumbsSlide.active").classList.remove("active");
                section.querySelectorAll(".productV8VisualThumbsSlide")[this.realIndex].classList.add("active");

                // pause all videos
                section.querySelectorAll(".productV8VisualSwiperSlide video").forEach(element => {
                    element.pause();
                });
            }
        }
    });

    // play video on slide play click
    section.querySelectorAll(".productV8VisualSwiperSlide").forEach(element => {
        element.addEventListener("click", function () {
            // get video
            const video = this.closest(".productV8VisualSwiperSlide").querySelector("video");

            if (!video) {
                return;
            }

            // remove play button if it hasn't already been removed
            this.querySelector(".productV8VisualSwiperSlidePlay")?.remove();

            // show controls
            video.controls = true;

            // play video
            video.play();
        });
    });

    // change slide on thumbnail click
    section.querySelectorAll(".productV8VisualThumbsSlide").forEach(element => {
        element.addEventListener("click", function () {
            // change slide
            productSwiper.slideTo(this.dataset.index - 1);
        });
    });

    // update active variant on input changes
    section.querySelectorAll("input, select").forEach(function (element) {
        element.addEventListener("change", function () {
            updateProduct();
        });
    })

    /**************
     Update Product
     ***************/

    async function updateProduct() {
        // Find the active variant
        if (product.variants.length === 1) {
            // default fallback
            activeVariant = product.variants[0];
        } else {
            // collect options from inputs
            let options = [];
            section.querySelectorAll(`.productV8ControlsItem.option`).forEach(group => {
                options.push(group.querySelector(`input:checked`).value);
            });

            // find new variant based on the options
            activeVariant = product.variants.find((variant) => {
                return JSON.stringify(variant.options) === JSON.stringify(options)
            });
        }

        // check if variant wasn't found
        if (!activeVariant || forceSoldOut) {
            section.querySelector(".productV8ATC").disabled = true;
            section.querySelector(".productV8ATCTxt").textContent = "Not Available";
            return;
        }


        /**************
         Price
         ***************/


        const compareEl = section.querySelector(".productV8ATCPriceCompare");
        const realEl = section.querySelector(".productV8ATCPriceReal");

        if (activeVariant.compare_at_price > activeVariant.price) {
            compareEl.textContent = price(activeVariant.compare_at_price, true);
        } else {
            compareEl.textContent = "";
        }
        realEl.textContent = price(activeVariant.price, true);


        // update price
        const priceText = price(activeVariant.price);


        /**************
         ATC Enable/Disable
         ***************/

        // check if the variant is in stock
        if (activeVariant.available && !forceSoldOut) {
            section.querySelector(".productV8ATC").disabled = false;
            section.querySelector(".productV8ATCTxt").textContent = "Add To Cart";
        } else {
            section.querySelector(".productV8ATC").disabled = true;
            section.querySelector(".productV8ATCTxt").textContent = "Sold Out";
        }

        // update url with variant id so the selected options are maintained on refresh
        let url = new URL(window.location.href);
        url.searchParams.set("variant", activeVariant.id);
        window.history.replaceState({}, "", url);
    }

    // cherub icon bugfix
    // check if productVisualThumbs is ontop of productWrapper svg
    let bottomSectionExists = section.querySelector('.productV8Wrapper') || false;
    if (bottomSectionExists) {
        let cherubEl = section.querySelector('.productV8Wrapper .cherub');
        let thumbsEl = section.querySelector('.productV8VisualThumbs');
        let cherubRect = cherubEl.getBoundingClientRect();
        let thumbsRect = thumbsEl.getBoundingClientRect();
        if (window.innerWidth > 1000 && cherubRect.top < thumbsRect.bottom) {
            // if the thumbs are ontop of the cherub, drop it down
            let i = 0;
            while (cherubRect.top < thumbsRect.bottom && i < 200) {
                cherubRect = cherubEl.getBoundingClientRect();
                thumbsRect = thumbsEl.getBoundingClientRect();
                cherubEl.style.top = (100 + i) + "px";
                i++;
            }
        }
    }

    // on load, update the product
    // this accomplishes loading the correct variant image and price on page load
    updateProduct();

    /**************
     Flavor (switch product)
     ***************/
    section.querySelector('.productV8ControlsFlavor').addEventListener('change', function () {
        // go to that product
        window.location.href = this.value;
    });

    /**************
     Product ATC
     ***************/

    async function addToCart() {

        // add loading animation to both buttons
        section.querySelector(".productV8ATC").classList.add("loading");

        let formData = {
            items: [{
                quantity: quantity,
                id: activeVariant.id,
            }]
        };

        let addBarsProperty = true;
        if (product.variants.length !== 1) {
            addBarsProperty = false;
        } else if (activeVariant.title.includes('Bars') || activeVariant.title.includes('Pack')) {
            addBarsProperty = false;
        }

        if (addBarsProperty) {
            // check for bars per box
            let barsPer = parseInt(section.querySelector(".productV8ATC").dataset.bars);
            // check if there are parentheses in the bars per value, if so, extract the number within the parentheses
            let parenthesesMatch = section.querySelector(".productV8ATC").dataset.bars.match(/\(([^)]+)\)/);
            if (parenthesesMatch) {
                barsPer = parseInt(parenthesesMatch[1]);
            }
            if (barsPer && barsPer > 0) {
                // if the product has bars per box, set the quantity to the bars per value
                formData.items[0].properties = {
                    "Bars": barsPer
                };
            }
        }


        // add product
        await addProduct(formData);

        // remove loading animation
        section.querySelector(".productV8ATC").classList.remove("loading");

        // open cart
        await openCart();
    }

    section.querySelector('.productV8ATC').addEventListener("click", addToCart);

}());

